import clsx from 'clsx';
import React, { forwardRef, ReactNode } from 'react';

type IconShape = 'square' | 'round' | 'circle';

interface MenuProps {
	children?: ReactNode;
	className?: string;
	iconShape?: IconShape;
	popperArrow?: boolean;
	subMenuBullets?: boolean;
	innerSubMenuArrows?: boolean;
}

const Menu = forwardRef<HTMLElement, MenuProps>(
	(
		{
			children,
			className,
			iconShape,
			popperArrow = true,
			subMenuBullets = false,
			innerSubMenuArrows = true,
			...rest
		},
		ref,
	) => {
		const menuRef = ref || React.createRef<HTMLElement>();
		return (
			<nav
				ref={menuRef}
				className={clsx('bay-sidenav-menu', className, {
					[`shaped ${iconShape}`]:
						iconShape && ['square', 'round', 'circle'].indexOf(iconShape) >= 0,
					'submenu-bullets': subMenuBullets,
					'inner-submenu-arrows scrollbar-sm': innerSubMenuArrows,
				})}
				{...rest}
			>
				<ul>
					{React.Children.toArray(children)
						.filter(Boolean)
						.map((child, index) =>
							React.isValidElement(child)
								? React.cloneElement(child, {
									key: index,
									firstchild: 1,
									popperarrow: popperArrow === true ? 1 : 0,
								} as any)
								: child,
						)}
				</ul>
			</nav>
		);
	},
);

Menu.displayName = 'Menu';

export default Menu;
